import { AnimatePresence, motion } from "motion/react";
import React, { useMemo } from "react";
import { Variants } from "../../animations/variants";
import { useRotatingContent } from "../../hooks/use_rotating_content";
import { DeweyLogo } from "../../icons";
import { useConfig } from "../../providers/config_provider";

export default function Searching() {
  const { organization } = useConfig();
  const { name, strings } = organization;
  const { loadingMessages } = strings;

  // Alternate message used when the user has submitted a query
  const alternateContent = useMemo(() => {
    return `Got it! Looking through the ${name} library for you now... `;
  }, [name]);

  // Use the hook to figure out which message to display
  const content = useRotatingContent(loadingMessages, alternateContent);

  return (
    <motion.div
      variants={Variants.FadeInDown}
      initial="initial"
      animate="animate"
      exit="exit"
      className="dewey--searching"
    >
      <div className="dewey--searching--loader">
        <DeweyLogo className="dewey--searching--loader--icon" />
      </div>
      <AnimatePresence mode="wait">
        <motion.p
          key={content}
          variants={Variants.TextRotation}
          initial="initial"
          animate="animate"
          exit="exit"
          className="dewey--searching--label"
        >
          {content}
        </motion.p>
      </AnimatePresence>
    </motion.div>
  );
}
